 <div class="advertisement-header">
        <h1>Advertisement</h1>
</div>
<div class="advertisement-content">
      <p *ngFor="let advertisement of advertisementList" class="add-font-20">
        <ng-template [ngIf]="advertisement?.pdfUrl">
            <a [href]="advertisement?.pdfUrl" target="_blank">
                <img src="/assets/svg/pdf-add.svg" alt="pdf-add" />
                <span class="margin-left-10"> {{advertisement.title}} </span>
            </a>
        </ng-template>
        <ng-template [ngIf]="advertisement?.imagePath">
            <a [href]="advertisement?.imagePath" target="_blank">
                <img src="/assets/svg/image-add.svg" alt="image-add" />
                <span class="margin-left-10">{{advertisement.title}}</span>
            </a>
        </ng-template>
        <ng-template [ngIf]="advertisement?.video">
            <img src="/assets/svg/youtube-add.svg" alt="youtube-add" />
            <a [href]="getSafeUrl(advertisement?.video)" target="_blank">
                <span class="margin-left-10">{{advertisement.title}}</span>
            </a>
        </ng-template>
    </p>

</div>
   